import styled from 'styled-components';
import { constrastColor } from 'utils/colors/contrastColor';
import { ButtonProps, ContainerProps } from './Preview.types';

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const Content = styled.div`
  max-width: 300px;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 30px;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  background-color: #00000050;
`;

export const Logo = styled.img`
  max-width: 150px;
  max-height: 100px;
`;

export const Title = styled.h1`
  color: var(--color-background-primary);
  font-size: 1rem;
  font-weight: 700;
  margin: 20px 0 8px 0;
`;

export const Description = styled.p`
  color: var(--color-background-primary);
  font-size: 12px;
  font-weight: 400;
  margin: 0;
`;

export const InputField = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
  width: 100%;
  min-height: 24px;
  max-width: 300px;
  background-color: var(--color-background-primary);
  font-size: 12px;
  margin-bottom: 15px;

  > p {
    margin: 0 0 0 7px;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 300px;
  width: 100%;
  margin-top: 20px;
`;

export const Label = styled.label`
  color: var(--color-background-primary);
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
`;

export const Button = styled.button<ButtonProps>`
  width: 100%;
  color: ${({ backgroundColor }) => constrastColor(backgroundColor)};
  border: none;
  font-weight: 700;
  border-radius: 5px;
  padding: 7px;
  margin-top: 10px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const ContainerCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const Checkbox = styled.div`
  width: 8px;
  height: 8px;
  border: 0.5px solid var(--color-background-primary);
  border-radius: 50%;
  background-color: transparent;
`;

export const LabelCheckbox = styled.label`
  font-size: 11px;
  color: var(--color-background-primary);
  margin-left: 5px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
`;

export const DeveloperBy = styled.p`
  font-size: 8px;
  color: var(--color-background-primary);
  margin: 0;
`;

export const CredihomeText = styled.p`
  font-size: 12px;
  color: var(--color-background-primary);
  margin: 0;
`;
